// pages/affiliates/AffiliateLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api'; // ✅ Utilise le service API centralisé
import styles from './AffiliateLogin.module.css';

const AffiliateLogin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        console.log('🔐 Tentative connexion affilié...');

        try {
            // ✅ Utilise api.post - l'URL sera /api/affiliates/login automatiquement
            const response = await api.post('/affiliates/login', formData);
            const data = response.data;

            if (data.success) {
                // Stocker le token affilié (séparé du token user normal)
                localStorage.setItem('affiliateToken', data.token);
                localStorage.setItem('affiliateInfo', JSON.stringify(data.affiliate));
                
                console.log('✅ Connexion affilié réussie:', data.affiliate);
                
                // Rediriger vers le dashboard
                navigate('/affiliates/dashboard');
            } else {
                setError(data.message || 'Erreur de connexion');
            }
        } catch (err) {
            console.error('❌ Erreur login affilié:', err);
            
            // Gérer les différents types d'erreurs
            if (err.response) {
                // Erreur du serveur (4xx, 5xx)
                if (err.response.status === 404) {
                    setError('Route non trouvée. Vérifiez que le backend est configuré.');
                } else {
                    setError(err.response.data?.message || 'Email ou mot de passe incorrect');
                }
            } else if (err.request) {
                // Pas de réponse du serveur
                setError('Impossible de contacter le serveur');
            } else {
                setError('Erreur de connexion');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h1>🚀 Espace Affilié</h1>
                    <p>Connecte-toi pour suivre tes performances</p>
                </div>

                <form onSubmit={handleSubmit} className={styles.form}>
                    {error && (
                        <div className={styles.error}>
                            {error}
                        </div>
                    )}

                    <div className={styles.inputGroup}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="ton@email.com"
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className={styles.inputGroup}>
                        <label htmlFor="password">Mot de passe</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="••••••••"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button 
                        type="submit" 
                        className={styles.submitBtn}
                        disabled={loading}
                    >
                        {loading ? 'Connexion...' : 'Se connecter'}
                    </button>
                </form>

                <div className={styles.footer}>
                    <p>Un problème ? Contacte-nous</p>
                    <a href="mailto:support@rizzmaster.app">support@rizzmaster.app</a>
                </div>
            </div>
        </div>
    );
};

export default AffiliateLogin;